export function getCommentSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },
    {
      name: "equipment_id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: true,
      readOnly: true,
      error: false,
    },
    {
      name: "observation_id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: true,
      readOnly: true,
      error: false,
    },
    {
      name: "checklist_id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: true,
      readOnly: true,
      error: false,
    },
    {
      name: "issue_id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: true,
      readOnly: true,
      error: false,
    },
    {
      name: "Comment Description",
      default: "",
      type: "string",
      maxLength: 500,
      selectables: [],
      similair: ["desc", "note", "notes", "issue", "issues", "describe"],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
  ];
}
